import { useTranslation } from 'cng-web-lib'
import SCOInvMgmtKeys from 'src/constants/locale/key/SCOInvMgmt'
import Namespace from 'src/constants/locale/Namespace'
import CommonTranslationText from '../common/CommonTranslationText'

const SupplierTranslationText = () => {
    const commonText = CommonTranslationText();
    const { translate } = useTranslation(Namespace.SCO_INV_MGMT);
    const moduleTitle = translate(Namespace.SCO_INV_MGMT, SCOInvMgmtKeys.MODULE_TITLE)
    const supplierName = translate(Namespace.SCO_INV_MGMT, SCOInvMgmtKeys.SUPPLIER_NAME)
    const partyName = translate(Namespace.SCO_INV_MGMT, SCOInvMgmtKeys.PARTY_NAME)
    const supplierDetails = translate(Namespace.SCO_INV_MGMT, SCOInvMgmtKeys.SUPPLIER_DETAILS)
    const supplierAddress = translate(Namespace.SCO_INV_MGMT, SCOInvMgmtKeys.SUPPLIER_ADDRESS)
    
    return {
        moduleTitle,
        supplierName,
        partyName,
        supplierDetails,
        supplierAddress,
        ...commonText
    }
}

export default SupplierTranslationText
